export const GetTemplates = (id) => {

  return $.get('LogTemplate/GetMinLogTemplates?IsActive=null&skip=null&take=null&locationId='+id)

}

export const GetLocations = () => {

  return $.get('Location/GetLocations')

}



export const DeleteChemicalChecklist = (model) => {

  return $.ajax({
    url: 'LogTemplate/DeleteLogTemplate?Id='+model,
    data: JSON.stringify(model),

    contentType: 'application/json',

    cache: false,
    type: 'POST'
  })

}


export const CopyChemicalChecklist = (model) => {

  return $.ajax({
    url: 'LogTemplate/CopyLogTemplates',
    data: JSON.stringify(model),

    contentType: 'application/json',

    cache: false,
    type: 'POST'
  })

}



export const AddChemicalChecklist = (model) => {

  return $.ajax({
    url: 'Chemical/AddChemicalChecklist',
    data: JSON.stringify(model),

    contentType: 'application/json',

    cache: false,
    type: 'POST'
  })

}

export const ActivateChemicalChecklist = (model) => {

  return $.post('LogTemplate/ChangeStatusLogTemplate?Id='+model[0].Id+'&activeStatus='+model[0].IsActive)

}

export const UpdateChemicalChecklist = (model) => {
  return $.ajax({
    url: 'Chemical/UpdateChemicalChecklist',
    data: JSON.stringify(model),

    contentType: 'application/json',

    cache: false,
    type: 'POST'
  })

}


export const GetChemicalChecklist = (id) => {

  return $.get('Chemical/GetChemicalChecklist?LocationId='+id)

}

export const GetChemicalChecklistDetails  = (id) => {

  return $.get('Chemical/GetChemicalChecklistDetails?chemicalChecklistId='+id)

}

export const GetLocationPools = () => {

  return $.get('Location/GetLocationPools')

}






// WEBPACK FOOTER //
// ./src/components/ChemicalChecklist/chemicalsettings.service.js